module.exports = __webpack_public_path__ + "media/wyposazenie/ilosc-drzwi@2x-6af21c7a.png";